/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/PersonMatches/Content/PersonMatch/Info/Details/Person/Address/Content"
  
}) {
let personMatchAddressValueData = fromData.useDataFormat({ viewPath,
context: 'person_match',
path: 'address',
format: fromHelpers.getAddress,
})
let dtTypographyFontsizeS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.s'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={dtTypographyFontsizeS}
 data="person_match.address"
 format="helpers.js getAddress"
 text={personMatchAddressValueData}
/>
</div>
{children}
</React.Fragment>)
}